<template>
  <v-card color="green lighten-5">
    <v-card-title>
      <v-icon class="mr-3">fa-credit-card</v-icon>
      <span>{{$route.params.id}}SMS</span>
      <span class="ml-10 text-uppercase">{{$t('card.prof.title')}}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="close" color="error">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" :lazy-validation="true">
        <v-row>
          <v-col cols="12" md="2" class="hidden-sm-and-down">
            <v-img height="200px" width="161px" src="../../assets/profile.png"></v-img>
          </v-col>
          <v-col cols="12" md="10">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="item.first_name"
                  :label="$t('card.prof.first_name')"
                  :placeholder="$t('label.placeholder')"
                  background-color="yellow lighten-5"
                  color="black"
                  clearable
                  shaped
                  outlined
                  counter="32"
                  :rules="[v => v==null ||v.length<=32 || $t('error.lenght')]"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  v-model="item.second_name"
                  clearable
                  background-color="yellow lighten-5"
                  color="black"
                  outlined
                  height="16px"
                  shaped
                  counter="32"
                  :label="$t('card.prof.second_name')"
                  :placeholder="$t('label.placeholder')"
                  :rules="[v => v==null ||v.length<=32 || $t('error.lenght')]"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  v-model="item.company_name"
                  clearable
                  background-color="yellow lighten-5"
                  color="black"
                  outlined
                  shaped
                  counter="64"
                  :label="$t('card.prof.company_name')"
                  :placeholder="$t('label.placeholder')"
                  :rules="[v => v==null ||v.length<=64 || $t('error.lenght')]"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  v-model="item.company_subname"
                  clearable
                  background-color="yellow lighten-5"
                  color="black"
                  outlined
                  shaped
                  counter="64"
                  :label="$t('card.prof.company_subname')"
                  :placeholder="$t('label.placeholder')"
                  :rules="[v => v==null ||v.length<=64 || $t('error.lenght')]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="item.reg_num"
              clearable
              outlined
              background-color="yellow lighten-5"
              color="black"
              :label="$t('card.prof.reg_num')"
              :placeholder="$t('label.placeholder')"
              shaped
              counter="32"
              :rules="[v =>v==null || v.length<=32 || $t('error.lenght')]"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="a_email"
              clearable
              outlined
              background-color="yellow lighten-5"
              color="black"
              :label="$t('card.prof.email')"
              :placeholder="$t('label.placeholder')"
              shaped
              counter="32"
              :rules="email_rule"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="a_phone"
              clearable
              outlined
              background-color="yellow lighten-5"
              color="black"
              prefix="+"
              :label="$t('card.prof.phone')"
              :placeholder="$t('label.placeholder')"
              shaped
              counter="32"
              :rules="phone_rule"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-menu
              v-model="bday_menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-chip-group column>
                  <v-chip
                    v-for="date in bdays"
                    :key="date"
                    color="blue lighten-5"
                    close
                    @click:close="remDate(date)"
                  >
                    <v-icon class="mr-1" color="orange">mdi-star</v-icon>
                    {{date}}
                  </v-chip>
                  <v-chip v-on="on">
                    <v-icon>mdi-plus</v-icon>
                    <span>{{$t("card.prof.add_date")}}</span>
                  </v-chip>
                </v-chip-group>
              </template>
              <v-date-picker
                ref="bd_picker"
                :locale="$i18n.locale"
                no-title
                @click:date="addDate"
                :max="$moment().subtract(10,'year').format()"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-checkbox v-model="sms_allow" label="Send sms-messages" class="mx-3"></v-checkbox>
          <v-checkbox v-model="email_allow" label="Send emails"></v-checkbox>
        </v-row>
        <v-row>
          <v-col cols="12">{{item.additional}}</v-col>
          <v-col cols="12" v-if="alertMessage">
            <v-alert
              v-model="showAlert"
              border="left"
              colored-border
              type="error"
              elevation="2"
              :dismissible="true"
              transition="fade-transition"
            >{{alertMessage}}</v-alert>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-if="$store.getters.test('CardRecord.w')"
        color="blue darken-1"
        text
        @click="save"
      >{{$t('button.save')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import app from "@/app.js";

export default {
  name: "CardEditorSms",
  props: {
    record: { type: Object, required: true },
    value: { type: Boolean }
  },
  data() {
    return {
      bday_menu: false,
      bdays: [],
      showAlert: false,
      alertMessage: "",
      item: { ...this.record },
      email_rule: [
        v =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("error.email")
      ],
      phone_rule: [v => !v || /^['+']?(371)?\d{8}$/gi.test(v) || this.$t("error.phone")]
    };
  },
  watch: {
    bday_menu(val) {
      val &&
        this.$nextTick().then(() => {
          this.$refs.bd_picker.activePicker = "YEAR";
        });
    },
    record: {
      handler(nw) {
        this.item = { ...nw };
        this.setBdays();
      },
      deep: true
    }
  },
  mounted() {
    this.setBdays();
  },
  computed: {
    sms_allow: {
      get() {
        return this.getTag("sendsms");
      },
      set(v) {
        this.setTag("sendsms", v);
      }
    },
    a_email: {
      get() {
        return this.getTag("email");
      },
      set(v) {
        this.setTag("email", v);
      }
    },
    a_phone: {
      get() {
        return this.getTag("phone");
      },
      set(v) {
        this.setTag("phone", v);
      }
    },
    email_allow: {
      get() {
        return this.getTag("sendeml");
      },
      set(v) {
        this.setTag("sendeml", v);
      }
    }
  },
  methods: {
    setBdays() {
      try {
        let bd = this.getTag("bdays");
        if (bd) this.bdays = bd.split(",");
        else this.bdays = [];
      } catch (e) {
        this.bdays = [];
        console.log(e);
      }
    },
    addDate(d) {
      try {
        if (this.bdays.indexOf(d) == -1) this.bdays.push(d);
      } catch (e) {
        console.log(e);
      }
      this.bday_menu = false;
    },
    remDate(d) {
      try {
        let i = this.bdays.indexOf(d);
        if (i != -1) this.bdays.splice(i, 1);
      } catch (e) {
        console.log(e);
      }
    },
    getTag(t, def) {
      try {
        let ret = new RegExp("<" + t + ">(.+)</" + t + ">", "gi").exec(
          this.item.additional
        );
        return ret ? ret[1] : def ? def : "";
      } catch (e) {
        return null;
      }
    },
    setTag(t, v) {
      const exp = new RegExp("<" + t + ">(.+)</" + t + ">", "gi");
      let newval = "<" + t + ">" + v + "</" + t + ">";
      if (exp.exec(this.item.additional)) {
        this.item.additional = this.item.additional.replace(
          exp,
          v ? newval : ""
        );
      } else {
        if (v) this.item.additional += newval;
      }
    },
    close() {
      this.item = { ...this.record };
      this.$emit("input", false);
    },
    save() {
      if (!this.$refs.form.validate()) return;
      try {
        if (this.bdays.length) {
          this.setTag("bdays", this.bdays.join());
        }else{
          this.setTag("bdays", "");
        }
      } catch (e) {
        console.log(e);
      }
      let params = {
        id: this.item.id,
        firstName: this.item.first_name,
        secondName: this.item.second_name,
        companyName: this.item.company_name,
        companySubName: this.item.company_subname,
        regNumber: this.item.reg_num,
        additional: this.item.additional
        // pin: this.item.pin,
        // status: this.item.status,
        // validExt: this.item.valid.split(' ')[0],
      };
      app
        .update(this.item.id, "CardRecord", params)
        .then(() => {
          this.$emit("update", this.item);
          this.close();
        })
        .catch(error => {
          this.showAlertMessage(error);
        });
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    }
  }
};
</script>

<style scoped>
</style>